import * as React from "react";
import { VUtils } from "../../utils";
export class SettlementView extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const cityDimensions = Math.sqrt(this.props.Settlement.CityMilesSq).toPrecision(3).toLocaleString();
        const countrysideDimensions = Math.sqrt(this.props.Settlement.CountrysideMilesSq).toPrecision(3).toLocaleString();
        const avgVillagePop = Math.floor(this.props.Settlement.CountrysidePopulation / this.props.Settlement.SupportingVillages).toLocaleString();
        return (React.createElement("div", { className: "laff-column" },
            React.createElement("h3", null, "Town Stats"),
            React.createElement("dl", null,
                React.createElement("dt", null, "Population"),
                React.createElement("dd", null, this.props.Settlement.CityPopulation.toLocaleString()),
                React.createElement("dt", null, "City Area Miles\u00B2"),
                React.createElement("dd", null, `${VUtils.prettyPrintRounded(this.props.Settlement.CityMilesSq)} (${cityDimensions}² miles)`),
                React.createElement("dt", null, "Countryside Population"),
                React.createElement("dd", null, this.props.Settlement.CountrysidePopulation.toLocaleString()),
                React.createElement("dt", null, "Countryside Area Miles\u00B2"),
                React.createElement("dd", null, `${VUtils.prettyPrintRounded(this.props.Settlement.CountrysideMilesSq)} (${countrysideDimensions}² miles)`),
                React.createElement("dt", null, "Villages"),
                React.createElement("dd", null, `${this.props.Settlement.SupportingVillages.toLocaleString()} (${avgVillagePop.toLocaleString()} avg people)`),
                React.createElement("dt", null, "Services"),
                React.createElement("dd", null, this.props.Settlement.Services.length.toLocaleString()),
                React.createElement("dt", null, "Total Buildings"),
                React.createElement("dd", null, this.props.Settlement.TotalBuildings.toLocaleString())),
            React.createElement("h3", null, "Town Professions"),
            React.createElement("dl", null, [...VUtils.groupBy(this.props.Settlement.Services, ((service) => service.Name))].sort((a, b) => {
                if (a[0] < b[0]) {
                    return -1;
                }
                else {
                    return 1;
                }
            }).map((service) => {
                return (React.createElement(React.Fragment, null,
                    React.createElement("dt", null, service[0]),
                    React.createElement("dd", null, service[1].length)));
            }))));
    }
}
//# sourceMappingURL=settlementview.js.map